<template>
  <div class="container">
    <div class="ourwork_detail_banner">
      <router-link class="link" to="/index">
        <img src="@/assets/images/home.svg" />
      </router-link>
      <span class="divide"> > </span>
      <router-link class="link" to="/ourwork"> Ourwork </router-link>
      <span class="divide"> > </span>
      <router-link class="link" to=""> {{ projectDetail.title }} </router-link>
    </div>
    <div class="ourwork_detail_wrapper">
      <div class="ourwork_give_wrapper">
        <img class="ourwork_img" :src="projectDetail.coverUrl" />
        <div class="ourwork_give">
          <div class="title">{{ projectDetail.title }}</div>
          <Payment :dedicateId="projectDetail.projectId" />
        </div>
      </div>
      <div class="ourwork_detail_content">
        <img class="ourwork_bg" src="@/assets/images/ourwork_bg.svg" />
        <div class="ourwork_detail" v-html="projectDetail.details"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { computed, ref, reactive, onMounted, toRaw, h, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { fetchProjectDetail } from '@/api/common.js';
import Payment from '@/components/Payment.vue';

const route = useRoute();
const store = useStore();

const projectDetail = reactive({
  projectId: '',
  title: '',
  details: '',
  describe: '',
});

const getProjectDetail = () => {
  fetchProjectDetail(route.params.id).then((res) => {
    if (res.code == 200) {
      Object.assign(projectDetail, res.data);
    }
  });
};

onMounted(() => {
  getProjectDetail();
});
</script>

<style lang="less">
.ourwork_detail {
  img,
  iframe,
  video {
    border-radius: 8px;
    max-width: 100%;
  }
}
@media (max-width: 768px) {
  .ourwork_detail {
    img,
    iframe,
    video {
      height: auto;
    }
  }
}
</style>

<style lang="less" scoped>
.container {
  margin: 40px auto;
  width: 1080px;
  .ourwork_detail_banner {
    margin: 32px auto;
    .divide {
      margin: 0 12px;
    }
    .link {
      color: #3d3d3d;
      text-decoration: none;
      cursor: pointer;
      line-height: 24px;
    }
  }
  .ourwork_detail_wrapper {
    .ourwork_give_wrapper {
      display: flex;
      gap: 45px;
      .ourwork_img {
        width: 450px;
        border-radius: 12px;
        height: fit-content;
      }
      .ourwork_give {
        flex: 1;
        .title {
          font-size: 26px;
          font-weight: bold;
          margin-bottom: 24px;
        }
      }
    }
    .ourwork_detail_content {
      margin-top: 80px;
      min-height: 600px;
      .ourwork_bg {
        width: 100%;
        position: absolute;
        top: 520px;
        left: 0;
        right: 0;
        z-index: -1;
      }
      .ourwork_detail {
        padding: 64px;
        line-height: normal;
      }
    }
  }
}
@media (max-width: 768px) {
  .container {
    width: 100%;
    padding: 0 24px;
    .ourwork_detail_banner {
      margin: 12px auto 24px;
    }
    .ourwork_detail_wrapper {
      .ourwork_give_wrapper {
        flex-wrap: wrap;
        .ourwork_img {
          width: 100%;
        }
        .ourwork_give {
          width: 100%;
        }
      }
      .ourwork_detail_content {
        width: 100%;
        margin-top: 40px;
        .ourwork_bg {
          top: 820px;
        }
        .ourwork_detail {
          padding: 12px;
        }
      }
    }
  }
}
</style>
